var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      { staticClass: "d-flex justify-content-center mb-1" },
      [
        _vm.loadingSpinner
          ? _c("b-spinner", {
              staticStyle: { width: "3rem", height: "3rem" },
              attrs: { variant: "success", span: "Spinning", block: "" },
            })
          : _vm._e(),
      ],
      1
    ),
    !_vm.loadingSpinner
      ? _c(
          "section",
          { staticClass: "invoice-preview-wrapper" },
          [
            _c(
              "b-row",
              { staticClass: "invoice-preview" },
              [
                _c(
                  "b-col",
                  { attrs: { cols: "12", xl: "9", md: "8" } },
                  [
                    _c(
                      "b-card",
                      {
                        staticClass: "invoice-preview-card px-1",
                        attrs: { "no-body": "", id: "invoice-preview-card" },
                      },
                      [
                        _c(
                          "b-card-body",
                          { staticClass: "invoice-padding pb-0" },
                          [
                            _c(
                              "div",
                              { staticClass: "row align-items-center mb-2" },
                              [
                                _c("div", {}, [_c("Logo")], 1),
                                _c("div", { staticClass: "col-9" }, [
                                  _c("div", {}, [_c("CompanyName")], 1),
                                  _c("div", {}, [_c("Address")], 1),
                                ]),
                              ]
                            ),
                            _c(
                              "b-card-body",
                              { staticClass: "invoice-padding pt-0" },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c("div", { staticClass: "col-6" }, [
                                    _c(
                                      "div",
                                      { staticClass: "invoice-spacing" },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _c("h6", { staticClass: "mb-2" }, [
                                              _vm._v("Supplier"),
                                            ]),
                                            _c("CompanyAddress", {
                                              attrs: {
                                                supplier: _vm.supplierId,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ]),
                                  _c("div", { staticClass: "col-6" }, [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "invoice-number-date mt-md-0 mt-2",
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center justify-content-md-end mb-1",
                                          },
                                          [
                                            _c("h4", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(this.headerName) +
                                                  " #" +
                                                  _vm._s(
                                                    _vm.purchaseorderId
                                                      .orderNumber
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ]
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center my-2",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title" },
                                              [_vm._v(" Issued Date: ")]
                                            ),
                                            _c("flat-pickr", {
                                              staticClass:
                                                "form-control invoice-edit-input",
                                              attrs: { disabled: "" },
                                              model: {
                                                value:
                                                  _vm.purchaseorderId.issueDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchaseorderId,
                                                    "issueDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchaseorderId.issueDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "d-flex align-items-center",
                                          },
                                          [
                                            _c(
                                              "span",
                                              { staticClass: "title" },
                                              [_vm._v(" Due Date: ")]
                                            ),
                                            _c("flat-pickr", {
                                              staticClass:
                                                "form-control invoice-edit-input",
                                              attrs: { disabled: "" },
                                              model: {
                                                value:
                                                  _vm.purchaseorderId.dueDate,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.purchaseorderId,
                                                    "dueDate",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "purchaseorderId.dueDate",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        this.vat
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center my-2",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "title me-2" },
                                                  [_vm._v("VAT:")]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "invoice-date mb-0",
                                                  },
                                                  [_vm._v(_vm._s(this.vat))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        this.vat
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "d-flex align-items-center my-2",
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "title me-2" },
                                                  [_vm._v("BRN Number:")]
                                                ),
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "invoice-date mb-0",
                                                  },
                                                  [_vm._v(_vm._s(this.brn))]
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]
                                    ),
                                  ]),
                                ]),
                                _c("div", {
                                  staticClass:
                                    "d-flex justify-content-between flex-md-row flex-column invoice-spacing mt-0",
                                }),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("hr", { staticClass: "invoice-spacing" }),
                        _c("b-table", {
                          attrs: {
                            responsive: "",
                            fields: _vm.dynamicFields,
                            items: _vm.purchaseorderId.purchaseOrderItems,
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "cell(itemId)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.getItemName(data.item.itemId)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(cost)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      " Rs " +
                                        _vm._s(data.item.cost.toFixed(2)) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(qty)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          parseFloat(
                                            data.item.quantity
                                          ).toFixed(2)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(VAT)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          data.item.saleTaxPercentage
                                            ? parseFloat(
                                                data.item.saleTaxPercentage
                                              ).toFixed(2)
                                            : 0
                                        ) +
                                        " % "
                                    ),
                                  ]
                                },
                              },
                              {
                                key: "cell(price)",
                                fn: function (data) {
                                  return [
                                    _vm._v(
                                      " Rs " +
                                        _vm._s(
                                          (
                                            data.item.cost * data.item.quantity
                                          ).toFixed(2)
                                        ) +
                                        " "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1214502601
                          ),
                        }),
                        _c(
                          "b-card-body",
                          { staticClass: "invoice-padding pb-0" },
                          [
                            _c(
                              "b-row",
                              [
                                _c(
                                  "b-col",
                                  {
                                    staticClass: "mt-md-0 mt-3",
                                    attrs: {
                                      cols: "12",
                                      md: "6",
                                      order: "2",
                                      "order-md": "1",
                                    },
                                  },
                                  [
                                    _c("b-card-text", { staticClass: "mb-0" }, [
                                      _c(
                                        "span",
                                        { staticClass: "font-weight-bold" },
                                        [_vm._v("Salesperson :")]
                                      ),
                                      _c("span", { staticClass: "ml-75" }, [
                                        _vm._v(
                                          _vm._s(
                                            _vm.purchaseorderId.salesPersonId
                                          ) + " "
                                        ),
                                      ]),
                                    ]),
                                  ],
                                  1
                                ),
                                _c(
                                  "b-col",
                                  {
                                    staticClass:
                                      "mt-md-6 d-flex justify-content-end",
                                    attrs: {
                                      cols: "12",
                                      md: "6",
                                      order: "1",
                                      "order-md": "2",
                                    },
                                  },
                                  [
                                    !this.purchaseorderId.hidePrice
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "invoice-total-wrapper",
                                          },
                                          [
                                            _c("hr", { staticClass: "my-50" }),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "invoice-total-item",
                                              },
                                              [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "invoice-total-title",
                                                  },
                                                  [_vm._v("Total:")]
                                                ),
                                                _vm.purchaseorderId.total
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "invoice-total-amount",
                                                      },
                                                      [
                                                        _vm._v(
                                                          " Rs " +
                                                            _vm._s(
                                                              _vm.purchaseorderId.total.toFixed(
                                                                2
                                                              )
                                                            ) +
                                                            " "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c("hr", { staticClass: "invoice-spacing" }),
                        _c(
                          "b-card-body",
                          { staticClass: "invoice-padding pt-0" },
                          [
                            _c("span", { staticClass: "font-weight-bold" }, [
                              _vm._v("Note: "),
                            ]),
                            _c("span", [
                              _vm._v(_vm._s(_vm.purchaseorderId.note)),
                            ]),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "b-col",
                  {
                    staticClass: "invoice-actions",
                    attrs: { cols: "12", md: "4", xl: "3" },
                  },
                  [
                    _c(
                      "b-card",
                      [
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(186, 191, 199, 0.15)",
                                expression: "'rgba(186, 191, 199, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            staticClass: "mb-75",
                            attrs: { variant: "outline-secondary", block: "" },
                            on: { click: _vm.printQuotation },
                          },
                          [_vm._v(" Print / Download ")]
                        ),
                        _vm.supplierId.phoneNumber && _vm.tenant
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(186, 191, 199, 0.15)",
                                    expression: "'rgba(186, 191, 199, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                staticClass: "mb-75",
                                attrs: { variant: "info", block: "" },
                                on: { click: _vm.openWhatsApp },
                              },
                              [
                                _c("img", {
                                  staticClass: "w-10",
                                  attrs: {
                                    src: require("@/assets/images/logo/whatsapp.png"),
                                  },
                                }),
                                _vm._v(" Whatsapp "),
                              ]
                            )
                          : _vm._e(),
                        _vm.canConvert
                          ? _c(
                              "b-button",
                              {
                                directives: [
                                  {
                                    name: "ripple",
                                    rawName: "v-ripple.400",
                                    value: "rgba(186, 191, 199, 0.15)",
                                    expression: "'rgba(186, 191, 199, 0.15)'",
                                    modifiers: { 400: true },
                                  },
                                ],
                                staticClass: "mb-75",
                                attrs: {
                                  variant: "outline-secondary",
                                  block: "",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.convertPO(_vm.purchaseorderId)
                                  },
                                },
                              },
                              [_vm._v(" Convert ")]
                            )
                          : _vm._e(),
                        _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "ripple",
                                rawName: "v-ripple.400",
                                value: "rgba(186, 191, 199, 0.15)",
                                expression: "'rgba(186, 191, 199, 0.15)'",
                                modifiers: { 400: true },
                              },
                            ],
                            staticClass: "mb-75",
                            attrs: { variant: "outline-secondary", block: "" },
                            on: {
                              click: function ($event) {
                                return _vm.viewPurchaseOrderDocuments(_vm.id)
                              },
                            },
                          },
                          [_vm._v(" Documents ")]
                        ),
                        _c(
                          "b-modal",
                          {
                            ref: "modal-view-purchase-order-document",
                            attrs: {
                              id: "modal-view-purchase-order-document",
                              "ok-only": "",
                              "ok-title": "View",
                              centered: "",
                              size: "lg",
                              title: "View Purchase Order Documents",
                              "hide-footer": true,
                            },
                          },
                          [
                            _c("DocumentUpload", {
                              attrs: { documentDetails: _vm.documentDetails },
                              on: {
                                deleteFile: _vm.deleteFile,
                                downloadFile: _vm.downloadFile,
                                uploadFiles: _vm.uploadFiles,
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }